import content from '../locales/en/content.json';
import { ADDRESS_REGEX } from './constants';
import {
  hasPrimaryCaregiver,
  hasSecondaryCaregiverOne,
  hasSecondaryCaregiverTwo,
} from './helpers';

export const validateCaregivers = (errors, _, formData) => {
  const hasPrimary = hasPrimaryCaregiver(formData);
  const hasSecondary = hasSecondaryCaregiverOne(formData);
  const hasCaregiver = hasPrimary || hasSecondary;

  // add a blank error to disable the ability to continue the form while not displaying the error itself
  if (!hasCaregiver) {
    errors.addError(' ');
  }
};

export const validateCountyInput = (errors, fieldData) => {
  const regex = new RegExp(ADDRESS_REGEX.county(), 'i');
  if (!regex.test(fieldData?.trim())) {
    errors.addError(content['validation-address--county-pattern']);
  }
};

export const validateSsnIsUnique = (errors, _, formData) => {
  const {
    veteranSsnOrTin,
    primarySsnOrTin,
    secondaryOneSsnOrTin,
    secondaryTwoSsnOrTin,
  } = formData;

  const allValidSSNs = [
    veteranSsnOrTin,
    hasPrimaryCaregiver(formData) ? primarySsnOrTin : undefined,
    hasSecondaryCaregiverOne(formData) ? secondaryOneSsnOrTin : undefined,
    hasSecondaryCaregiverTwo(formData) ? secondaryTwoSsnOrTin : undefined,
  ].filter(Boolean);

  if (allValidSSNs.length !== new Set(allValidSSNs).size) {
    errors.addError(content['validation-ssn-unique']);
  }
};
